<template>
  <div class="py-0 px-0 ma-0">
    <coin-chip :coins_amount="coins_amount" :status="status" :show-boost="showBoost"></coin-chip>
  </div>
</template>

<script setup>
import CoinChip from './CoinChip.vue';

const props = defineProps({
  coins_amount: Number,
  status: {
    type: String,
    default: 'normal',
    validator: (value) => ['normal', 'primary', 'cut'].includes(value),
  },
  showBoost: {
    type: Boolean,
    default: false
  }
});
</script>